import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../../../Context/ContextProvider";
import { useState } from "react";
import { FaSpinner } from "react-icons/fa";

export default function Deconnexion({ showLogout, handleCloseLogout }) {
  const navigate = useNavigate();
  const { token, setToken, setUser } = useStateContext();
  const [isLoggingOutGlobal, setIsLoggingOutGlobal] = useState(false);

  if (!showLogout) return null;

  const handleLogoutGlobal = () => {
    setIsLoggingOutGlobal(true);

    axios
      .delete("https://catalogue.mg.formafusion.io/api/logout", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setToken(null);
        setUser(null);
        setIsLoggingOutGlobal(false);
        navigate("/");
      })
      .catch((error) => {
        console.error("Erreur lors de la déconnexion:", error);
        setIsLoggingOutGlobal(false);
      });
  };

  return (
    <div className="fixed top-0 left-0 w-full  bg-black bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center px-4 h-[99vh]">
      <div className="bg-white shadow-xl rounded-2xl w-full max-w-md p-6 animate-fade-in-up ">
        <h2 className="text-xl font-semibold text-center text-gray-800 mb-4">
          Confirmer la déconnexion
        </h2>
        <p className="text-sm text-gray-600 text-center mb-6">
          Êtes-vous sûr de vouloir vous déconnecter ?
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={handleCloseLogout}
            className="px-4 py-2 rounded-lg text-sm font-medium border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
          >
            Annuler
          </button>
          <button
            className="bg-[#8E548E] text-[#D0D8FD] px-6 py-2 rounded-lg text-sm font-semibold flex items-center justify-center"
            onClick={handleLogoutGlobal}
            disabled={isLoggingOutGlobal}
          >
            {isLoggingOutGlobal ? (
              <FaSpinner className="animate-spin w-5 h-5" />
            ) : (
              "Oui, confirmer"
            )}
          </button>

        </div>
      </div>
    </div>
  );
}
